import { render, staticRenderFns } from "./IconSortDescendingSolid.vue?vue&type=template&id=4198a048"
import script from "./IconSortDescendingSolid.vue?vue&type=script&lang=js"
export * from "./IconSortDescendingSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports